<template>
    <div>
      <div class="tabs">
        <button
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ active: index === activeTabIndex }"
          @click="activeTabIndex = index"
        >
          {{ tab.title }}
        </button>
      </div>
      <div class="tab-content">
        <slot />
      </div>
    </div>
  </template>
  
  <script>
  import { provide, reactive, toRefs } from 'vue';
  
  export default {
    name: 'Tabs',
    setup() {
      const state = reactive({
        tabs: [],
        activeTabIndex: 0,
      });
  
      const register = (tab) => {
        state.tabs.push(tab);
        return {
          isActive: () => state.tabs.indexOf(tab) === state.activeTabIndex,
          unregister: () => {
            const index = state.tabs.indexOf(tab);
            if (index > -1) state.tabs.splice(index, 1);
          }
        };
      };
  
      provide('tabs-register', register);
      provide('active-tab-index', toRefs(state).activeTabIndex);
  
      return { ...toRefs(state) };
    }
  };
  </script>
  
  <style>
  .tabs {
    display: flex;
    cursor: pointer;
  }
  .tabs button {
    padding: 10px;
    border: none;
    background: none;
  }
  .tabs button.active {
    font-weight: bold;
    border-bottom: 2px solid #000;
  }
  .tab-content {
    margin-top: 20px;
    min-width: 150px; /* Ajusta esto según sea necesario */
  }
  </style>
  